export default __webpack_public_path__ + "static/media/LocationPin.5a9f5682.mov";